import { HubConnectionBuilder } from '@microsoft/signalr';


const startConnectiion = async connection => {

  if (connection.state === 'Disconnected') {
    await connection.start();
  }
}
const useSignalRHub = (endpoint, options = {}) => {

  const newConnection = new HubConnectionBuilder()
    .withUrl(`${window.location.origin}/${endpoint}`, options)
    .withAutomaticReconnect()
    .build();

  return {
    instance: newConnection,
    start: () => startConnectiion(newConnection),
    stop: () => newConnection.stop()
  }

}

export default useSignalRHub